module.exports = __webpack_public_path__ + "img/sp.1f9b0ba2.png";